import { useCallback, useState } from 'react'
import { VisitorRegistrationFormWorker } from '../../../../../types/Company'
import Dialog from '../../../../atoms/feedback/Dialog'
import { FlexColumn, FlexRow } from '../../../../atoms/layout/Flex'
import Button from '../../../../atoms/inputs/Button'
import Label from '../../../../atoms/display/Label'
import Alert from '../../../../atoms/feedback/Alert'
import { useVisitorRegistrationFormWorkerCreateDialog } from '../../../../../hooks/useDialog'

type Props = {
  open: boolean
  onClose: () => void
  workers: VisitorRegistrationFormWorker[]
  selectedWorkers: VisitorRegistrationFormWorker[]
  onSelect: (workers: VisitorRegistrationFormWorker[]) => void
}

export default function VisitorRegistrationWorkerSelectDialog(props: Props) {
  const { open, onClose, workers, selectedWorkers, onSelect } = props
  const createDialog = useVisitorRegistrationFormWorkerCreateDialog()
  const [selectedIds, setSelectedIds] = useState<string[]>(selectedWorkers.map((worker) => worker.id))

  const handleSelect = useCallback(
    (worker: VisitorRegistrationFormWorker) => {
      setSelectedIds([...selectedIds, worker.id])
    },
    [setSelectedIds, selectedIds]
  )

  const handleUnSelect = useCallback(
    (worker: VisitorRegistrationFormWorker) => {
      setSelectedIds(selectedIds.filter((id) => id !== worker.id))
    },
    [setSelectedIds, selectedIds]
  )

  const handleSetting = useCallback(() => {
    onSelect(workers.filter((worker) => selectedIds.includes(worker.id)))
    onClose()
  }, [onSelect, onClose, workers, selectedIds])

  return (
    <Dialog
      open={open}
      width="xs"
      onClose={onClose}
      title="労働者の選択"
      actions={<Button onClick={handleSetting}>設定</Button>}
    >
      <FlexColumn>
        <Button height="small" onClick={() => createDialog.open()}>
          労働者情報の登録
        </Button>
        {workers.length === 0 && <Alert severity="info">労働者情報が登録されていません</Alert>}
        {workers.map((worker) => (
          <FlexRow key={worker.id} align="center">
            {selectedIds.includes(worker.id) ? (
              <Button size="sm" height="small" color="caution" onClick={() => handleUnSelect(worker)}>
                <Label text="解除" variant="caption" />
              </Button>
            ) : (
              <Button size="sm" height="small" onClick={() => handleSelect(worker)}>
                <Label text="選択" variant="caption" />
              </Button>
            )}
            <Label text={worker.name} />
          </FlexRow>
        ))}
      </FlexColumn>
    </Dialog>
  )
}
